import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

export const selectInfoBar = state => state.infoBar;

export const selectInfoBarConfig = createSelector(
  selectInfoBar, infoBar => infoBar.config,
);

export const selectDealOfTheWeek = createSelector(
  selectInfoBar, infoBar => infoBar.dealOfTheWeek,
);

export const selectSalesInfoBar = createSelector(
  selectInfoBar, infoBar => infoBar.salesInfoBar,
);

export const selectDealOfTheWeekOffer = createSelector(
  selectDealOfTheWeek, dealOfTheWeek => dealOfTheWeek.offer,
);

export const selectSalesInfoBarOffer = createSelector(
  selectSalesInfoBar, salesInfoBar => salesInfoBar.offer,
);

// Check if Deal Of The Week and Infobar Sales are loaded
export const selectInfoBarIsLoaded = createSelector([
  selectDealOfTheWeek, selectSalesInfoBar], (dealOfTheWeek, salesInfoBar) => (
  dealOfTheWeek.isLoaded && salesInfoBar.isLoaded
));

// Check if Deal Of The Week and Infobar Sales are loading
export const selectInfoBarIsLoading = createSelector([
  selectDealOfTheWeek, selectSalesInfoBar], (dealOfTheWeek, salesInfoBar) => (
  dealOfTheWeek.isLoading && salesInfoBar.isLoading
));

export const selectInfoBarOffers = createSelector([
  selectDealOfTheWeekOffer, selectSalesInfoBarOffer], (...offers) => (
  offers.filter(offer => !isEmpty(offer))
));
